import api from './api';

// Discord community linking — Account tab. The shared `api` instance is fine
// here (unlike 2FA): a 401 on these calls really does mean a dead session.

export interface DiscordStatus {
  available: boolean; // false until the server has DISCORD_* env configured
  linked: boolean;
  username: string | null;
}

export const discord = {
  status: async (): Promise<DiscordStatus> =>
    (await api.get('/api/discord/status')).data,

  // Returns the Discord authorize URL; the caller navigates to it. A plain
  // <a href> can't work because the endpoint needs the Bearer token.
  linkStart: async (): Promise<string> =>
    (await api.get('/api/discord/link/start')).data.url,

  unlink: async (): Promise<void> => {
    await api.post('/api/discord/unlink');
  },
};
